import { Observable, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import type { AutoSuggestSymbol } from '../../domain/symbol-lookup.domain';

export interface SymbolLookupSearchResolverOptions {
  readonly symbolQuery: string;
  readonly isRecentSearch: boolean;
  readonly currentSymbols: Array<AutoSuggestSymbol>;
  readonly search: () => Observable<Array<AutoSuggestSymbol>>;
}

/**
 * Resolves the autosuggest result stream for a given symbol query while preserving
 * the current symbol-lookup semantics around empty queries, recent-search display,
 * retries, and graceful error fallback.
 */
export function resolveSymbolLookupSearch(
  options: SymbolLookupSearchResolverOptions
): Observable<Array<AutoSuggestSymbol>> {
  const {
    symbolQuery,
    isRecentSearch,
    currentSymbols,
    search
  }: SymbolLookupSearchResolverOptions = options;

  if (symbolQuery === '') {
    return of(isRecentSearch ? currentSymbols : []);
  }

  return search().pipe(
    retry(2),
    catchError(() => of([]))
  );
}

